import { useTrackPageView } from '@hooks/useTrackPageView';
import type { PageProps } from '@models/pageProps';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Page: React.FC<PageProps> = ({ component: Component, ...rest }) => {
  useTrackPageView();

  return <Component {...rest} />;
};
